const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    return import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Store cleanup functions to disconnect PerformanceObservers
      const cleanupFunctions = [];

      // Each web-vitals function returns a cleanup function
      const clsCleanup = getCLS(onPerfEntry);
      const fidCleanup = getFID(onPerfEntry);
      const fcpCleanup = getFCP(onPerfEntry);
      const lcpCleanup = getLCP(onPerfEntry);
      const ttfbCleanup = getTTFB(onPerfEntry);

      // Store cleanup functions if they exist
      if (clsCleanup) cleanupFunctions.push(clsCleanup);
      if (fidCleanup) cleanupFunctions.push(fidCleanup);
      if (fcpCleanup) cleanupFunctions.push(fcpCleanup);
      if (lcpCleanup) cleanupFunctions.push(lcpCleanup);
      if (ttfbCleanup) cleanupFunctions.push(ttfbCleanup);

      // Return cleanup function to be called on unmount
      return () => {
        cleanupFunctions.forEach(cleanup => {
          if (cleanup && typeof cleanup === 'function') {
            cleanup();
          }
        });
      };
    });
  }
  return Promise.resolve(null);
};

export default reportWebVitals;
